module.exports = __webpack_public_path__ + "img/carac-princ3.d283f26f.jpg";